import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux-modules/store';
import { ProductDetailReleaseFeatures } from './containers/ProductDetailReleaseFeatures';
import { ProductDetailInstructionVideos } from './containers/ProductDetailInstructionVideos';
import { ProductDetailOnlineCourses } from './containers/ProductDetailOnlineCourses';
import { ProductDetailDocumentation } from './containers/ProductDetailDocumentation';
import { ProductDetailMarketingItems } from './containers/ProductDetailMarketingItems';
import ProductOverview from './containers/ProductOverview';
import SiteSearchBox from './containers/SiteSearchBox';
import { ProductDetailRelatedProducts } from './containers/ProductDetailRelatedProducts';
import { ProductDetailModulesParts } from './containers/ProductDetailModulesParts';
import SearchOverview from './containers/SearchOverview';

window.jQuery(() => {
  const productDetailReleaseFeatures = document.getElementById('product-detail-release-features');
  if (productDetailReleaseFeatures) {
    const {
      productId,
    } = productDetailReleaseFeatures.dataset;
    ReactDOM.createRoot(productDetailReleaseFeatures).render(
      <React.StrictMode>
        <Provider store={store}>
          <ProductDetailReleaseFeatures
            productId={productId}
            loadingText={productDetailReleaseFeatures.dataset.loadingText || ''}
          />
        </Provider>
      </React.StrictMode>,
    );
  }

  const productDetailInstructionVideos = document.getElementById('product-detail-instruction-videos');
  if (productDetailInstructionVideos) {
    const {
      productId,
    } = productDetailInstructionVideos.dataset;
    ReactDOM.createRoot(productDetailInstructionVideos).render(
      <React.StrictMode>
        <Provider store={store}>
          <ProductDetailInstructionVideos
            productId={productId}
            loadingText={productDetailInstructionVideos.dataset.loadingText || ''}
          />
        </Provider>
      </React.StrictMode>,
    );
  }

  const productDetailOnlineCourses = document.getElementById('product-detail-online-courses');
  if (productDetailOnlineCourses) {
    const {
      productId,
    } = productDetailOnlineCourses.dataset;
    ReactDOM.createRoot(productDetailOnlineCourses).render(
      <React.StrictMode>
        <Provider store={store}>
          <ProductDetailOnlineCourses
            productId={productId}
            loadingText={productDetailOnlineCourses.dataset.loadingText || ''}
          />
        </Provider>
      </React.StrictMode>,
    );
  }

  const productDetailDocumentation = document.getElementById('product-detail-documentation');
  if (productDetailDocumentation) {
    const {
      productId,
    } = productDetailDocumentation.dataset;
    ReactDOM.createRoot(productDetailDocumentation).render(
      <React.StrictMode>
        <Provider store={store}>
          <ProductDetailDocumentation
            productId={productId}
            loadingText={productDetailDocumentation.dataset.loadingText || ''}
          />
        </Provider>
      </React.StrictMode>,
    );
  }

  const productDetailModulesParts = document.getElementById('product-detail-modules-parts');
  if (productDetailModulesParts) {
    const {
      productId,
    } = productDetailModulesParts.dataset;
    ReactDOM.createRoot(productDetailModulesParts).render(
      <React.StrictMode>
        <Provider store={store}>
          <ProductDetailModulesParts
            productId={productId}
            loadingText={productDetailModulesParts.dataset.loadingText || ''}
          />
        </Provider>
      </React.StrictMode>,
    );
  }

  const productDetailMarketingItems = document.getElementById('product-detail-marketing-items');
  if (productDetailMarketingItems) {
    const {
      productId,
    } = productDetailMarketingItems.dataset;
    ReactDOM.createRoot(productDetailMarketingItems).render(
      <React.StrictMode>
        <Provider store={store}>
          <ProductDetailMarketingItems
            productId={productId}
            loadingText={productDetailMarketingItems.dataset.loadingText || ''}
          />
        </Provider>
      </React.StrictMode>,
    );
  }

  const productDetailRelatedProducts = document.getElementById('product-detail-related-products');
  if (productDetailRelatedProducts) {
    const {
      productId,
    } = productDetailRelatedProducts.dataset;
    ReactDOM.createRoot(productDetailRelatedProducts).render(
      <React.StrictMode>
        <Provider store={store}>
          <ProductDetailRelatedProducts
            productId={productId}
            loadingText={productDetailRelatedProducts.dataset.loadingText || ''}
          />
        </Provider>
      </React.StrictMode>,
    );
  }

  const productOverview = document.getElementById('product-overview');
  if (productOverview) {
    ReactDOM.createRoot(productOverview).render(
      <React.StrictMode>
        <Provider store={store}>
          <ProductOverview
            productsIndexName={productOverview.dataset.productsIndexName || ''}
            productsPublicUrl={productOverview.dataset.productsPublicUrl || ''}
            refreshUrl={productOverview.dataset.refreshUrl || ''}
            siteId={parseInt(productOverview.dataset.currentSite ?? '0', 10)}
            locale={productOverview.dataset.locale || ''}
            categoryUri={productOverview.dataset.categoryUri || null}
            categoryTitle={productOverview.dataset.categoryTitle || ''}
            loadingText={productOverview.dataset.loadingText || ''}
          />
        </Provider>
      </React.StrictMode>,
    );
  }

  const searchOverview = document.getElementById('search-overview');
  if (searchOverview) {
    ReactDOM.createRoot(searchOverview).render(
      <React.StrictMode>
        <Provider store={store}>
          <SearchOverview
            indexName={searchOverview.dataset.indexName || ''}
            publicUrl={searchOverview.dataset.publicUrl || ''}
            refreshUrl={searchOverview.dataset.refreshUrl || ''}
            siteId={parseInt(searchOverview.dataset.currentSite ?? '0', 10)}
            locale={searchOverview.dataset.locale || ''}
            loadingText={searchOverview.dataset.loadingText || ''}
            baseUrl={searchOverview.dataset.baseUrl || ''}
            userGroups={searchOverview.dataset.userGroups}
          />
        </Provider>
      </React.StrictMode>,
    );
  }

  const headerSearchForm = document.getElementById('site-search-form');
  if (headerSearchForm) {
    ReactDOM.createRoot(headerSearchForm).render(
      <React.StrictMode>
        <Provider store={store}>
          <SiteSearchBox
            indexName={headerSearchForm.dataset.indexName || ''}
            publicUrl={headerSearchForm.dataset.publicUrl || ''}
            refreshUrl={headerSearchForm.dataset.refreshUrl || ''}
            siteId={parseInt(headerSearchForm.dataset.currentSite ?? '0', 10)}
            locale={headerSearchForm.dataset.locale || ''}
            userGroups={headerSearchForm.dataset.userGroups}
            placeholder={headerSearchForm.dataset.placeholder || ''}
            searchUrl={headerSearchForm.dataset.searchUrl || ''}
          />
        </Provider>
      </React.StrictMode>,
    );
  }
});
